<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :rules="formRules"
        :submitData="submitData"
        @success="onSuccess"
        submit-btn-text="提交"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
      >
        <span>满配</span>
        <div style="display: flex">
          <div style="min-width: 300px">
            <el-form-item label="达标金额（元）" prop="complianceMax">
              <el-input-number
                style="width: 132px"
                v-model="formModel.complianceMax"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="达标商户数量（个）" prop="numberMax">
              <el-input-number
                style="width: 132px"
                v-model="formModel.numberMax"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="奖励金额（元）" prop="rewardMoneyMax">
              <el-input-number
                style="width: 132px"
                v-model="formModel.rewardMoneyMax"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="超标奖励/每个（元）" prop="outRewardMoneyMax">
              <el-input-number
                style="width: 132px"
                v-model="formModel.outRewardMoneyMax"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="最晚注册日期" prop="startDateMax">
          <el-input
            style="width: 132px; margin-left: 15px"
            v-model="formModel.startDateMax"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <span>中配</span>
        <div style="display: flex">
          <div style="min-width: 300px">
            <el-form-item label="达标金额（元）" prop="complianceMiddle">
              <el-input-number
                style="width: 132px"
                v-model="formModel.complianceMiddle"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="达标商户数量（个）" prop="numberMiddle">
              <el-input-number
                style="width: 132px"
                v-model="formModel.numberMiddle"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="奖励金额（元）" prop="rewardMoneyMiddle">
              <el-input-number
                style="width: 132px"
                v-model="formModel.rewardMoneyMiddle"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item
              label="超标奖励/每个（元）"
              prop="outRewardMoneyMiddle"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.outRewardMoneyMiddle"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="最晚注册日期" prop="startDateMiddle">
          <el-input
            style="width: 132px; margin-left: 15px"
            v-model="formModel.startDateMiddle"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <span>低配</span>
        <div style="display: flex">
          <div style="min-width: 300px">
            <el-form-item label="达标金额（元）" prop="complianceMin">
              <el-input-number
                style="width: 132px"
                v-model="formModel.complianceMin"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="达标商户数量（个）" prop="numberMin">
              <el-input-number
                style="width: 132px"
                v-model="formModel.numberMin"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="奖励金额（元）" prop="rewardMoneyMin">
              <el-input-number
                style="width: 132px"
                v-model="formModel.rewardMoneyMin"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="超标奖励/每个（元）" prop="outRewardMoneyMin">
              <el-input-number
                style="width: 132px"
                v-model="formModel.outRewardMoneyMin"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="最晚注册日期" prop="startDateMin">
          <el-input
            style="width: 132px; margin-left: 15px"
            v-model="formModel.startDateMin"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="开关" prop="status">
          <el-switch
            v-model="formModel.status"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import SelectLevel from "components/business/SelectLevel";
import ElFormItem from "element-ui/packages/form/src/form-item";
import TransactionService from "service/TransactionService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "merchantactivationmanage",
  data() {
    return {
      formRules: {
        numberMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        complianceMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        rewardMoneyMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        outRewardMoneyMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        startDateMax: [
          {
            required: true,
            // message: "请输入",
            validator: (rule, value, callback) => {
              const num = /^(0[0-9]|[1-3][0-9])$/.test(value);
              if (num == false || value > 31) {
                callback(new Error("请输入格式为01,02,03...31并且不得大于31"));
              } else {
                callback();
              }
            },
          },
        ],

        numberMiddle: [
          {
            required: true,
            message: "请输入",
          },
        ],
        complianceMiddle: [
          {
            required: true,
            message: "请输入",
          },
        ],
        rewardMoneyMiddle: [
          {
            required: true,
            message: "请输入",
          },
        ],
        outRewardMoneyMiddle: [
          {
            required: true,
            message: "请输入",
          },
        ],
        startDateMiddle: [
          {
            required: true,
            // message: "请输入",
            validator: (rule, value, callback) => {
              const num = /^(0[0-9]|[1-3][0-9])$/.test(value);
              if (num == false || value > 31) {
                callback(new Error("请输入格式为01,02,03...31并且不得大于31"));
              } else {
                callback();
              }
            },
          },
        ],

        numberMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        complianceMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        rewardMoneyMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        outRewardMoneyMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        startDateMin: [
          {
            required: true,
            // message: "请输入",
            validator: (rule, value, callback) => {
              const num = /^(0[0-9]|[1-3][0-9])$/.test(value);
              if (num == false || value > 31) {
                callback(new Error("请输入格式为01,02,03...31并且不得大于31"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      formModel: {
        numberMax: "",
        complianceMax: undefined,
        rewardMoneyMax: undefined,
        outRewardMoneyMax: undefined,
        startDateMax: undefined,

        numberMiddle: "",
        complianceMiddle: undefined,
        rewardMoneyMiddle: undefined,
        outRewardMoneyMiddle: undefined,
        startDateMiddle: undefined,

        numberMin: "",
        complianceMin: undefined,
        rewardMoneyMin: undefined,
        outRewardMoneyMin: undefined,
        startDateMin: undefined,
        status: "0",
        id: "",
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonElForm,
    SelectLevel,
  },
  computed: {
    submitData() {
      this.params = {
        numberMax: this.formModel.numberMax,
        startDateMax: this.formModel.startDateMax,
        complianceMax: this.formModel.complianceMax * 100,
        rewardMoneyMax: this.formModel.rewardMoneyMax * 100,
        outRewardMoneyMax: this.formModel.outRewardMoneyMax * 100,

        numberMiddle: this.formModel.numberMiddle,
        startDateMiddle: this.formModel.startDateMiddle,
        complianceMiddle: this.formModel.complianceMiddle * 100,
        rewardMoneyMiddle: this.formModel.rewardMoneyMiddle * 100,
        outRewardMoneyMiddle: this.formModel.outRewardMoneyMiddle * 100,

        numberMin: this.formModel.numberMin,
        startDateMin: this.formModel.startDateMin,
        complianceMin: this.formModel.complianceMin * 100,
        rewardMoneyMin: this.formModel.rewardMoneyMin * 100,
        outRewardMoneyMin: this.formModel.outRewardMoneyMin * 100,
        id: this.formModel.id,
        status: this.formModel.status,
      };
      // console.log(this.params);
      return this.params;
    },
    submitService() {
      return TransactionService.merchantactivationmanageUpdate;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.doLoad(
        TransactionService.merchantactivationmanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.formModel = result;
            this.formModel.complianceMax = this.formModel.complianceMax / 100;
            this.formModel.rewardMoneyMax = this.formModel.rewardMoneyMax / 100;
            this.formModel.outRewardMoneyMax =
              this.formModel.outRewardMoneyMax / 100;

            this.formModel.complianceMiddle =
              this.formModel.complianceMiddle / 100;
            this.formModel.rewardMoneyMiddle =
              this.formModel.rewardMoneyMiddle / 100;
            this.formModel.outRewardMoneyMiddle =
              this.formModel.outRewardMoneyMiddle / 100;

            this.formModel.complianceMin = this.formModel.complianceMin / 100;
            this.formModel.rewardMoneyMin = this.formModel.rewardMoneyMin / 100;
            this.formModel.outRewardMoneyMin =
              this.formModel.outRewardMoneyMin / 100;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.getDetail();
        this.showSuccess(res.contents);
      });
    },
    ...mapActions({}),
  },
};
</script>

<style scoped>
span {
  font-size: 17px;
  margin-bottom: 10px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/MerchantActivationManage.vue